export default __webpack_public_path__ + "static/media/Sandals of the Howling Giant.cfb083aa.jpg";